<template>
    <vx-modal v-model:visible="visible" padding="standard" size="sm">
        <template v-slot:header> Selected Numbers </template>

        <div class="flex flex-col gap-4">
            <div class="flex items-center gap-2">
                <vx-badge color="amber">
                    <font-awesome-icon widthAuto :icon="faGrid2Plus" />
                    {{ props.groupName }}
                </vx-badge>
                <span class="text-lg font-bold text-slate-800">
                    {{ pluralized('thread', props.threads.length, true) }}
                </span>
            </div>

            <div class="grid grid-cols-2 gap-x-4 gap-y-1 overflow-y-auto text-sm text-slate-800">
                <template v-for="thread in props.threads" :key="thread.contact_id">
                    <strong>
                        {{ thread.contact_name || '-' }}
                    </strong>
                    {{ thread.contact_phone ? formatPhoneNumber(thread.contact_phone) : '-' }}
                </template>
            </div>
        </div>
    </vx-modal>
</template>

<script lang="ts" setup>
import { faGrid2Plus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxModal } from '@voxie/frontend-components';
import { pluralized, formatPhoneNumber } from '~/components/filters';
import type { Thread } from '~/services/threads/threadsClient.types';

interface Props {
    groupName: string;
    threads: Thread[];
}

const props = defineProps<Props>();
const visible = defineModel<boolean>('visible', {
    default: false,
});
</script>
